import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FaCopy } from 'react-icons/fa';
import { CloseButton } from '../elements/CloseButton';
const styles = css `
  overflow: auto;
  width: 400px;

  .inner-container {
    padding: 5px;
    width: 100%;
    height: 180px;
    border: none;
  }

  .main-buttons-container {
    padding: 5px 0;
    border-bottom: 0.55px solid #ebebeb;
    display: flex;
    justify-content: space-between;
  }

  button {
    background-color: transparent;
    border: none;
    padding: 0 5px;
  }

  button:disabled {
    opacity: 0.6;
  }
`;
function CopyClipboardModal({ text, onClose, onCopyClick, }) {
    return (_jsxs("div", { css: styles, children: [_jsxs("div", { className: "main-buttons-container handle", children: [_jsx("button", { type: "button", onClick: () => onCopyClick(text), children: _jsx(FaCopy, {}) }), _jsx(CloseButton, { tooltip: "Close", onClick: onClose })] }), _jsx("div", { className: "inner-container", 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: text } })] }));
}
export default CopyClipboardModal;
